import { drawReeds, drawWater, ell, hash01, hills, skyGradient } from '../common';
import { smallPads } from './pond';
import type { DrawCtx, SceneArt } from './types';

function cloudBank(ctx: CanvasRenderingContext2D, x: number, y: number, k: number, color: string): void {
  ctx.fillStyle = color;
  ell(ctx, x, y, 70 * k, 22 * k);
  ctx.fill();
  ell(ctx, x + 45 * k, y - 14 * k, 44 * k, 24 * k);
  ctx.fill();
  ell(ctx, x - 40 * k, y - 8 * k, 38 * k, 18 * k);
  ctx.fill();
}

export const storm: SceneArt = {
  id: 'storm',
  rope: '#FF8A3D',
  ropeBack: '#C2601F',
  handle: '#FF8A3D',
  ring: 'rgba(255,255,255,0.8)',
  ground: {
    waterTop: '#3D6E78', waterBottom: '#1B3E47', shimmer: 'rgba(230,240,255,0.25)',
    padTop: '#4A9150', padEdge: '#22502A', padVein: 'rgba(20,60,30,0.4)',
    post: '#7A5238', postDark: '#5C3B26', postCap: '#9C7250', ripple: 'rgba(230,240,255,0.5)',
  },
  drawBack(d: DrawCtx) {
    const { ctx, v, t, fx } = d;
    skyGradient(ctx, v, [[0, '#3E4A58'], [0.7, '#6B7A88'], [1, '#93A0AA']]);
    // lightning bolt
    if (fx.bolt) {
      const b = fx.bolt;
      ctx.strokeStyle = `rgba(255,255,240,${1 - b.t / 0.35})`;
      ctx.lineWidth = 3;
      ctx.beginPath();
      let x = b.x;
      ctx.moveTo(x, v.T);
      for (let y = v.T; y < 340; y += 26) {
        x += (hash01(b.seed + y) - 0.5) * 50;
        ctx.lineTo(x, y);
      }
      ctx.stroke();
    }
    const span = v.R - v.L + 400;
    const speed = d.reduced ? 0 : 1;
    for (let i = 0; i < 7; i++) {
      const x = v.L - 200 + ((i * 160 + t * (26 + i * 5) * speed * (1 + Math.abs(d.gust))) % span);
      cloudBank(ctx, x, 170 + (i % 3) * 32, 0.9 + (i % 2) * 0.4, i % 2 ? '#2F3944' : '#45515E');
    }
    hills(ctx, v.L, v.R, 352, 30, 0.013, 0.9, '#4E6B58');
    hills(ctx, v.L, v.R, 362, 16, 0.022, 3.3, '#3E5A48');
    drawWater(ctx, v, t, this.ground, 2.2);
    smallPads(ctx, '#356B3C');
    const lean = d.gust * 14;
    drawReeds(ctx, 30, 3, t * 2.2, '#3F6A32', '#5E3A22', 9, lean);
    drawReeds(ctx, 762, 4, t * 2.2, '#3F6A32', '#5E3A22', 9, lean);
  },
  drawFront(d: DrawCtx) {
    const { ctx, v, t } = d;
    const W = v.R - v.L;
    const H = v.B - v.T;
    const n = d.reduced ? 50 : 140;
    const slant = 6 + d.gust * 10;
    ctx.strokeStyle = 'rgba(210,225,240,0.45)';
    ctx.lineWidth = 1.4;
    ctx.beginPath();
    for (let i = 0; i < n; i++) {
      const x = v.L + ((hash01(i) * W + t * 60 * (1 + d.gust)) % W + W) % W;
      const y = v.T + ((hash01(i + 300) * H + t * 720) % H);
      ctx.moveTo(x, y);
      ctx.lineTo(x - slant, y + 18);
    }
    ctx.stroke();
  },
};
